module.exports = __webpack_public_path__ + "img/LUB00135.a96d45f7.png";